if (!customElements.get('hero-slideshow')) {
  customElements.define(
    'hero-slideshow',
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        if (this.slides.length < 2) return;

        this.viewport = this.querySelector('[data-hero-viewport]');
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.index = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active'))
        );
        if (this.index < 0) this.index = 0;

        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = Math.max(2000, parseInt(this.dataset.speed || '5000', 10) || 5000);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.timer = null;

        this.onDot = this.onDot.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onVisibility = this.onVisibility.bind(this);
        this.pause = this.pause.bind(this);
        this.resume = this.resume.bind(this);

        this.dots.forEach((dot) => dot.addEventListener('click', this.onDot));
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('visibilitychange', this.onVisibility);

        if (this.autoplay && !this.reducedMotion) {
          this.addEventListener('mouseenter', this.pause);
          this.addEventListener('mouseleave', this.resume);
          this.addEventListener('focusin', this.pause);
          this.addEventListener('focusout', this.resume);
          this.start();
        }

        this.goTo(this.index, false);
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      onDot(event) {
        event.preventDefault();
        const i = parseInt(event.currentTarget.getAttribute('data-hero-dot'), 10);
        if (Number.isNaN(i)) return;
        this.goTo(i);
        this.restart();
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.index - 1);
          this.restart();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.index + 1);
          this.restart();
        }
      }

      onVisibility() {
        if (document.hidden) this.pause();
        else this.resume();
      }

      goTo(nextIndex, announce) {
        const total = this.slides.length;
        if (total < 1) return;

        const normalized = ((nextIndex % total) + total) % total;
        this.slides.forEach((slide, i) => {
          const active = i === normalized;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) slide.removeAttribute('tabindex');
          else slide.setAttribute('tabindex', '-1');
        });

        this.dots.forEach((dot, i) => {
          const active = i === normalized;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        this.index = normalized;

        if (announce !== false && this.viewport) {
          this.viewport.setAttribute('aria-live', 'polite');
        }
      }

      start() {
        this.stop();
        if (!this.autoplay || this.reducedMotion || this.slides.length < 2) return;
        this.timer = window.setInterval(() => this.goTo(this.index + 1), this.speed);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      pause() {
        this.stop();
      }

      resume() {
        if (this.autoplay && !this.reducedMotion && !document.hidden) this.start();
      }

      restart() {
        if (this.autoplay && !this.reducedMotion) this.start();
      }
    }
  );
}
